export const PHASE_NAME_MIN_LENGTH = 1;
export const PHASE_NAME_MAX_LENGTH = 100;
export const PHASE_DESCRIPTION_MIN_LENGTH = 1;
export const PHASE_DESCRIPTION_MAX_LENGTH = 500;
export const PHASE_PRIORITY_MIN = 1;
export const PHASE_PRIORITY_MAX = 5;
